"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteTree = void 0;
var NoteTree = /** @class */ (function () {
    function NoteTree(rootNote) {
        //
        // Non-hierarchical lookup table for notes.
        //
        this.notesLookup = new Map();
        this.rootNote = rootNote;
        //
        // Create a lookup table for notes.
        //
        this.createNoteLookup(this.rootNote);
    }
    //
    // Create a lookup table for notes.
    //
    NoteTree.prototype.createNoteLookup = function (note) {
        this.notesLookup.set(note.id, note);
        for (var _i = 0, _a = note.children; _i < _a.length; _i++) {
            var child = _a[_i];
            this.createNoteLookup(child);
        }
    };
    //
    // Gets the root note of the tree.
    //
    NoteTree.prototype.getRootNote = function () {
        return this.rootNote;
    };
    //
    // Gets a note by id.
    //
    NoteTree.prototype.getNote = function (id) {
        return this.notesLookup.get(id);
    };
    //
    // Adds a new note to the tree.
    //
    NoteTree.prototype.addNote = function (parentNote, childIndex, newNote) {
        this.notesLookup.set(newNote.id, newNote); // Track the new note in the lookup table.
        parentNote.children.splice(childIndex + 1, 0, newNote);
    };
    //
    // Removes a note from the tree.
    //
    NoteTree.prototype.removeNote = function (parentNote, childIndex) {
        var noteToDelete = parentNote.children.splice(childIndex, 1)[0];
        this.notesLookup.delete(noteToDelete.id); // Remove the deleted note from the lookup table.
    };
    //
    // Move a note from one parent to another.
    //
    NoteTree.prototype.moveNote = function (oldParentNote, oldChildIndex, newParentNote, newChildIndex) {
        var childNote = oldParentNote.children.splice(oldChildIndex, 1)[0];
        newParentNote.children.splice(newChildIndex, 0, childNote);
    };
    //
    // Finds the next note in a traversal of the tree.
    //
    NoteTree.prototype.getNextNote = function (parentNote, childIndex, grandParent, parentIndex) {
        var note = parentNote.children[childIndex];
        if (note.children.length > 0) {
            // Recurse down to the child.
            return note.children[0];
        }
        if (childIndex < parentNote.children.length - 1) {
            // Get the next sibling note.
            return parentNote.children[childIndex + 1];
        }
        if (grandParent !== undefined && parentIndex !== undefined) {
            if (parentIndex < grandParent.children.length - 1) {
                return grandParent.children[parentIndex + 1];
            }
        }
        return undefined;
    };
    //
    // Finds the previous note in a traversal of the tree.
    //
    NoteTree.prototype.getPrevNote = function (parentNote, childIndex) {
        if (childIndex > 0) {
            // Get the previous sibling note.
            var prevNote = parentNote.children[childIndex - 1];
            // Find the end of the sub-tree.
            while (prevNote.children.length > 0) {
                prevNote = prevNote.children[prevNote.children.length - 1];
            }
            return prevNote;
        }
        // Recurse up to the parent note.
        return parentNote;
    };
    return NoteTree;
}());
exports.NoteTree = NoteTree;
//# sourceMappingURL=note-tree.js.map